import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { createBrowserHistory } from "history";

import { PrivateRoute } from "../components/commons/PrivateRoute";
import config from "../config";

import Home from "../pages/Home";
import Error from "../pages/commons/Error";

import UserLogin from "../pages/auth/UserLogin";
import UserSignup from "../pages/auth/UserSignup";
import UserFullSignup from "../pages/auth/UserFullSignup";
import UserPassword from "../pages/auth/UserPassword";
import UserPasswordChange from "../pages/auth/UserPasswordChange";
import UserVerify from "../pages/auth/UserVerify";
import UserForgot from "../pages/auth/UserForgot";
import UserProfile from "../pages/auth/UserProfile";
import UserInfo from "../pages/auth/UserInfo";


import MyAppointments from "../pages/user/MyAppointments";
import MyAppointment from "../pages/user/MyAppointment";
import Videocall from "../pages/user/Videocall"
import MyPrescriptions from '../pages/user/MyPrescriptions';
import MyPrescription from '../pages/user/MyPrescription';

import Messages2 from "../pages/user/Messages";

import Professionals from "../pages/professionals/Professionals";
import Professional from "../pages/professionals/Professional";
import Pharmacies from "../pages/pharmacies/Pharmacies";
import Pharmacy from "../pages/pharmacies/Pharmacy";

import BookingType from "../pages/booking/BookingType";
import BookingCalendar from "../pages/booking/BookingCalendar";
import BookingClinicHistory from "../pages/booking/BookingClinicHistory";

import PurchaseMedicamentSearch from "../pages/purchases/PurchaseMedicamentSearch";
import PurchaseCart from "../pages/purchases/PurchaseCart";
import PurchaseReview from "../pages/purchases/PurchaseReview";

import MyPurchases from '../pages/user/MyPurchases';
import MyPurchase from '../pages/user/MyPurchase';


import InfoTerms from '../pages/info/InfoTerms';
import InfoPrivacy from '../pages/info/InfoPrivacy';
import InfoContactUs from '../pages/info/InfoContactUs';
import InfoHelp from '../pages/info/InfoHelp';

import Information from "../pages/commons/Information";
import Notifications from "../pages/user/Notifications";
import MyHistory from "../pages/user/MyHistory";

import Messages from "../pages/messages/Messages";
import Composer from "../pages/messages/Composer";
import ChatClass from "../pages/messages/ChatClass"
import Chat from "../pages/messages/Chat"
import VerifyPrescription from "../pages/info/VerifyPrescription";
import Verification from "../pages/auth/Verification";
import UserSignupWithVerification from '../pages/auth/UserSignupWithVerification';
import UserSignupWithVerification2 from '../pages/auth/UserSignupWithVerification2';
import ComposerClass from "../pages/messages/ComposerClass";


export const history = createBrowserHistory();

export const Routes = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  return (
    <Switch location={location}>
      <Route path={config.ROUTES.TERMS} exact component={InfoTerms} />
      <Route path={config.ROUTES.PRIVACY} exact component={InfoPrivacy} />
      <Route path={config.ROUTES.CONTACT_US} exact component={InfoContactUs} />
      <Route path={config.ROUTES.HELP} exact component={InfoHelp} />

      <Route path={config.ROUTES.LOGIN} exact component={UserLogin} />
      <Route path={config.ROUTES.SIGNUP} exact component={UserSignup} />
      <Route path={config.ROUTES.SIGNUP_FULL} exact component={UserFullSignup} />
      <Route path={config.ROUTES.PASSWORD} exact component={UserPassword} />
      <Route path={config.ROUTES.VERIFY} exact component={UserVerify} />
      <Route path={config.ROUTES.FORGOT} exact component={UserForgot} />      
      <Route path={config.ROUTES.VERIFY_PRESCRIPTION} exact component={VerifyPrescription}/>
      <Route path={config.ROUTES.VERIFICATION} exact component={Verification} />
      <Route path={config.ROUTES.SIGNUP_VERIFICATION} exact component={UserSignupWithVerification} />
      <Route path={config.ROUTES.SIGNUP_VERIFICATION2} exact component={UserSignupWithVerification2} />
      <Route path={config.ROUTES.SIGNUP_VERIFICATION_PREREGISTER} exact component={UserSignupWithVerification2} />
      
      <PrivateRoute path={config.ROUTES.USER.PASSWORD_CHANGE} exact component={UserPasswordChange} />
      <PrivateRoute path={config.ROUTES.USER.PROFILE} exact component={UserProfile} />
      <PrivateRoute path={config.ROUTES.USER.INFO} exact component={UserInfo} />      

      <PrivateRoute path={config.ROUTES.BOOKING.TYPE} exact component={BookingType} />
      <PrivateRoute path={config.ROUTES.BOOKING.CALENDAR} exact component={BookingCalendar} />
      <PrivateRoute path={config.ROUTES.BOOKING.CLINIC_HISTORY} exact component={BookingClinicHistory} />
      <PrivateRoute path={config.ROUTES.BOOKING.SUCCESS} exact component={Information} />

      <PrivateRoute path={config.ROUTES.APPOINTMENTS.LIST} exact component={MyAppointments}/>
      <PrivateRoute path={config.ROUTES.APPOINTMENTS.DETAIL} exact component={MyAppointment}/>
      <PrivateRoute path={config.ROUTES.APPOINTMENTS.CALL} exact component={Videocall}/>
      <PrivateRoute path={config.ROUTES.APPOINTMENTS.SUCCESS} exact component={Information}/>
      
      <PrivateRoute path={config.ROUTES.PRESCRIPTIONS} exact component={MyPrescriptions} />
      <Route path={config.ROUTES.PRESCRIPTION} exact component={MyPrescription} />

      <PrivateRoute path={config.ROUTES.MESSAGES} exact component={Messages} />
      <PrivateRoute path={config.ROUTES.NOTIFICATIONS} exact component={Notifications} />

      <PrivateRoute path={config.ROUTES.PURCHASES.LIST} exact component={MyPurchases} />
      <PrivateRoute path={config.ROUTES.PURCHASES.DETAIL} exact component={MyPurchase} />

      <PrivateRoute path={config.ROUTES.PURCHASES.SEARCH} exact component={PurchaseMedicamentSearch} />
      <PrivateRoute path={config.ROUTES.PURCHASES.CART} exact component={PurchaseCart} />
      <PrivateRoute path={config.ROUTES.PURCHASES.REVIEW} exact component={PurchaseReview} />

      <PrivateRoute path={config.ROUTES.PROFESSIONALS} exact component={Professionals} />
      <PrivateRoute path={config.ROUTES.PROFESSIONAL} exact component={Professional} />
      <PrivateRoute path={config.ROUTES.PHARMACIES} exact component={Pharmacies} />
      <PrivateRoute path={config.ROUTES.PHARMACY} exact component={Pharmacy} />

      <PrivateRoute path={config.ROUTES.MESSAGES} exact component={Messages} />
      <PrivateRoute path={config.ROUTES.CHAT} exact component={ChatClass} />
      <PrivateRoute path={config.ROUTES.CREATE_MESSAGE} exact component={ComposerClass} />

      <PrivateRoute path={config.ROUTES.HISTORY} exact component={MyHistory} />

      <PrivateRoute path={config.ROUTES.NOTIFICATIONS} exact component={Notifications} />
      
      <PrivateRoute path={config.ROUTES.SUCCESS} exact component={Information} />

      <PrivateRoute path={config.ROUTES.HOME} exact component={Home} />

      <Route><Error title={t("404")} headline={t("Page not found!")} button={t("Go back")} /></Route>
    </Switch>
  );
};
